import { SHOP_NUMBER_REGEX } from "@stadium/constants/shop";
import { BYSTADIUM_HOSTNAME } from "./app-routes";
import { MY_WORKSPACE_SLUG, INVITE_TOKEN_UUID_SEPERATOR } from "@stadium/constants";

const DEFAULT_OBJ = {};

// extracts shop number from url that ends with the shop number
export const getShopNumberfromUrl = (shopUrl) => shopUrl?.match(SHOP_NUMBER_REGEX)?.[0];

export const getShopUrl = ({ slug, shopNumber }) =>
  `${BYSTADIUM_HOSTNAME}/stores/${slug}/${shopNumber}`;

export const getStoreSlugFromUrlWithWorkspace = (slug) =>
  slug?.split?.(INVITE_TOKEN_UUID_SEPERATOR)?.[0] || "";

export const getWorkspaceSlugFromStoreSlug = (slug, returnAsIs = false) => {
  if (returnAsIs) {
    return slug || MY_WORKSPACE_SLUG;
  }
  return slug?.split(INVITE_TOKEN_UUID_SEPERATOR)?.[1] || MY_WORKSPACE_SLUG;
};

export const getCountryCodeAndLangFromPathname = (localeCode = "") => {
  if (!localeCode) return {};
  const [countryCode = "", lang = ""] = localeCode.split("-");
  return { countryCode, lang };
};

export const extractSlugsFromParams = (params = DEFAULT_OBJ) => {
  const {
    countryCode: localeCode = "",
    storeIdentifier = "",
    workspaceSlug = "",
    ...rest
  } = params;

  if (!localeCode.includes("-")) {
    return params;
  }
  const { countryCode, lang } = getCountryCodeAndLangFromPathname(localeCode);
  return {
    ...rest,
    ...(localeCode && { countryCode, lang }),
    ...(storeIdentifier && { slug: storeIdentifier }),
    ...(workspaceSlug && { workspaceSlug }),
    isNewRoute: true,
  };
};

const hasCombinedLocaleCode = (countryCode) =>
  countryCode != null && String(countryCode).includes("-");

const resolveCountryCodeAndLang = ({ rawCountryCode, lang, isNewRoute }) => {
  if (!isNewRoute || !hasCombinedLocaleCode(rawCountryCode)) {
    return { countryCode: rawCountryCode, effectiveLang: lang };
  }

  const parsed = getCountryCodeAndLangFromPathname(String(rawCountryCode));
  if (!parsed.countryCode) {
    return { countryCode: rawCountryCode, effectiveLang: lang };
  }

  return {
    countryCode: parsed.countryCode,
    effectiveLang: lang || parsed.lang,
  };
};

const formatRouteCountryCode = (countryCode, effectiveLang, isNewRoute) =>
  isNewRoute ? `${countryCode}-${effectiveLang}` : countryCode;

const getRoutePathIdentifiers = ({ isNewRoute, slug, storeNumber, workspaceSlug, lang }) =>
  isNewRoute
    ? {
        storeIdentifier: slug,
        ...(workspaceSlug && { workspaceSlug }),
      }
    : { storeNumber, slug, lang };

export const generateQueryForRoutePath = (params) => {
  const {
    countryCode: rawCountryCode,
    lang,
    slug,
    storeNumber,
    isNewRoute,
    workspaceSlug,
    ...rest
  } = params;

  const { countryCode, effectiveLang } = resolveCountryCodeAndLang({
    rawCountryCode,
    lang,
    isNewRoute,
  });

  return {
    countryCode: formatRouteCountryCode(countryCode, effectiveLang, isNewRoute),
    ...getRoutePathIdentifiers({ isNewRoute, slug, storeNumber, workspaceSlug, lang }),
    ...rest,
  };
};
